<template>
  <div class="card-box" :class="{ outlookAddin }">
    <div class="form-group">
      <!-- Logo, subtitle, and sign up text -->
      <h1 class="logo fade-in-load-logo" aria-label="Login">
        <img src="~assets/img/qreserve.svg" alt="QReserve" />
      </h1>

      <div style="text-align: center">
        <p style="font-weight: bold; font-size: larger">
          QReserve is currently undergoing maintenance to improve the platform.
        </p>
        <div class="gears">
          <div class="gears-container">
            <div class="gear-rotate"></div>
            <div class="gear-rotate-left"></div>
          </div>
        </div>
        <p>
          We apologize for this inconvenience and are working hard to complete
          this work quickly.
        </p>
        <p>
          <a href="https://status.qreserve.com" target="_blank">
            Visit our Status Page for Details
          </a>
        </p>
      </div>
    </div>
    <div class="terms-box">
      <a href="https://get.qreserve.com/legal/terms/" target="_blank">
        Terms of use
      </a>
      &nbsp;&nbsp;&middot;&nbsp;&nbsp;
      <a href="https://get.qreserve.com/legal/privacy/" target="_blank">
        Privacy policy
      </a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'maintenance-card',

  created() {
    this.setTitle('Maintenance Underway');
  },

  emits: [],

  methods: {},

  mounted() {},

  props: {
    // Boolean
    outlookAddin: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/css/colors';
@import '~assets/css/partials/login';

.card-box {
  .default-sso {
    text-align: center;
    margin-top: 2em;
    span {
      display: block;
      color: #444;
    }
    .logo {
      margin-bottom: 10px;
      max-height: 60px;
      img {
        height: 100%;
        width: auto;
      }
    }
    .name {
      font-size: larger;
      font-weight: bold;
    }
  }
}

.btn-default-sso {
  margin-top: 0.6em;
}

.remember-me-switch {
  font-size: 1.1em;
  padding-right: 0;
}

.powered {
  position: absolute;
  top: -4px;
  right: 8px;
  img {
    height: 8px;
  }
}

.hint-success {
  color: $successcolor;
}

span.form-icon {
  position: absolute;
  margin-top: 6px;
  margin-left: 8px;
  z-index: 10;
  opacity: 0.4;
}

.form-icon-offset {
  padding: 12px 28px;
}

.button-box-sso-remember-indent {
  padding-left: 3rem;
  padding-top: 1rem;
}

.outlookAddin {
  border: none;
  box-shadow: none;
}

.theme-banner {
  padding: 0.2em;
  margin-top: 1.2em;
  font-size: smaller;
  margin-left: -20px;
  margin-right: -20px;
  text-align: center;

  .btn-link {
    padding: 0;
    display: inline;
    height: 1.2em;
    line-height: 1.2em;
  }
}

.gears {
  width: 48%;
  display: inline-block;
}
.gears:first-child {
  margin-right: 3%;
}
.gears-container {
  width: 150px;
  height: 100px;
  font-size: 24px;
  padding: 9%;
  position: relative;
  margin: 20px auto 0;
}
.gear-rotate {
  width: 2em;
  height: 2em;
  top: 50%;
  left: 50%;
  margin-top: -1em;
  margin-left: -0.4em;
  background: #2879b2;
  position: absolute;
  border-radius: 1em;
  -webkit-animation: 2s gear-rotate linear infinite;
  -moz-animation: 2s gear-rotate linear infinite;
  animation: 2s gear-rotate linear infinite;
}
.gear-rotate-left {
  margin-top: -2.2em;
  top: 50%;
  width: 2em;
  height: 2em;
  background: #1e394c;
  position: absolute;
  border-radius: 1em;
  -webkit-animation: 2s gear-rotate-left linear infinite;
  -moz-animation: 2s gear-rotate-left linear infinite;
  animation: 2s gear-rotate-left linear infinite;
}

.gear-rotate::before {
  width: 2.8em;
  height: 2.8em;
  background:
    -webkit-linear-gradient(
      0deg,
      transparent 39%,
      #2879b2 39%,
      #2879b2 61%,
      transparent 61%
    ),
    -webkit-linear-gradient(
        60deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      ),
    -webkit-linear-gradient(
        120deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      );
  background:
    -moz-linear-gradient(
      0deg,
      transparent 39%,
      #2879b2 39%,
      #2879b2 61%,
      transparent 61%
    ),
    -moz-linear-gradient(
        60deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      ),
    -moz-linear-gradient(
        120deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      );
  background:
    -o-linear-gradient(
      0deg,
      transparent 39%,
      #2879b2 39%,
      #2879b2 61%,
      transparent 61%
    ),
    -o-linear-gradient(
        60deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      ),
    -o-linear-gradient(
        120deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      );
  background:
    -ms-linear-gradient(
      0deg,
      transparent 39%,
      #2879b2 39%,
      #2879b2 61%,
      transparent 61%
    ),
    -ms-linear-gradient(
        60deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      ),
    -ms-linear-gradient(
        120deg,
        transparent 42%,
        #2879b2 42%,
        #2879b2 58%,
        transparent 58%
      );
  background:
    linear-gradient(
      0deg,
      transparent 39%,
      #2879b2 39%,
      #2879b2 61%,
      transparent 61%
    ),
    linear-gradient(
      60deg,
      transparent 42%,
      #2879b2 42%,
      #2879b2 58%,
      transparent 58%
    ),
    linear-gradient(
      120deg,
      transparent 42%,
      #2879b2 42%,
      #2879b2 58%,
      transparent 58%
    );
  position: absolute;
  content: '';
  top: -0.4em;
  left: -0.4em;
  border-radius: 1.4em;
}
.gear-rotate-left::before {
  width: 2.8em;
  height: 2.8em;
  background:
    -webkit-linear-gradient(
      0deg,
      transparent 39%,
      #1e394c 39%,
      #1e394c 61%,
      transparent 61%
    ),
    -webkit-linear-gradient(
        60deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      ),
    -webkit-linear-gradient(
        120deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      );
  background:
    -moz-linear-gradient(
      0deg,
      transparent 39%,
      #1e394c 39%,
      #1e394c 61%,
      transparent 61%
    ),
    -moz-linear-gradient(
        60deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      ),
    -moz-linear-gradient(
        120deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      );
  background:
    -o-linear-gradient(
      0deg,
      transparent 39%,
      #1e394c 39%,
      #1e394c 61%,
      transparent 61%
    ),
    -o-linear-gradient(
        60deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      ),
    -o-linear-gradient(
        120deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      );
  background:
    -ms-linear-gradient(
      0deg,
      transparent 39%,
      #1e394c 39%,
      #1e394c 61%,
      transparent 61%
    ),
    -ms-linear-gradient(
        60deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      ),
    -ms-linear-gradient(
        120deg,
        transparent 42%,
        #1e394c 42%,
        #1e394c 58%,
        transparent 58%
      );
  background:
    linear-gradient(
      0deg,
      transparent 39%,
      #1e394c 39%,
      #1e394c 61%,
      transparent 61%
    ),
    linear-gradient(
      60deg,
      transparent 42%,
      #1e394c 42%,
      #1e394c 58%,
      transparent 58%
    ),
    linear-gradient(
      120deg,
      transparent 42%,
      #1e394c 42%,
      #1e394c 58%,
      transparent 58%
    );
  position: absolute;
  content: '';
  top: -0.4em;
  left: -0.4em;
  border-radius: 1.4em;
}
.gear-rotate::after,
.gear-rotate-left::after {
  width: 1em;
  height: 1em;
  position: absolute;
  content: '';
  top: 0.5em;
  left: 0.5em;
  border-radius: 0.5em;
}
.gear-rotate::after {
  background: #1e394c;
}
.gear-rotate-left::after {
  background: #2879b2;
}

/*
 * Keyframe Animations
 */
@-webkit-keyframes gear-rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(-180deg);
  }
}

@-moz-keyframes gear-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-180deg);
  }
}

@keyframes gear-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-180deg);
  }
}

@-webkit-keyframes gear-rotate-left {
  0% {
    -webkit-transform: rotate(30deg);
  }
  100% {
    -webkit-transform: rotate(210deg);
  }
}

@-moz-keyframes gear-rotate-left {
  0% {
    -webkit-transform: rotate(30deg);
  }
  100% {
    -webkit-transform: rotate(210deg);
  }
}

@keyframes gear-rotate-left {
  0% {
    -webkit-transform: rotate(30deg);
  }
  100% {
    -webkit-transform: rotate(210deg);
  }
}
</style>
